import produce from 'immer';
import { ActionType, getType } from 'typesafe-actions';
import * as actions from './actions';
import { IVideoStyleState } from './types';

const INITIAL_STATE: IVideoStyleState = {
  themeId: null,
  style: null,
  music: {
    tag: null,
    trackId: null,
  },
  isShortFlowInactive: null,
};

function reducer(state: IVideoStyleState, action: ActionType<typeof actions>) {
  if (!state) {
    state = INITIAL_STATE;
  }

  return produce(state, (draftState) => {
    switch (action.type) {
      case getType(actions.storeVideoThemeId):
        draftState.themeId = action.payload;
        break;

      case getType(actions.storeVideoStyle):
        draftState.style = action.payload;
        break;

      case getType(actions.storeMusicTag):
        draftState.music.tag = action.payload;
        break;

      case getType(actions.storeMusicTrackId):
        draftState.music.trackId = action.payload;
        break;

      case getType(actions.deactivateShortFlow):
        draftState.isShortFlowInactive = true;
        break;

      default:
    }
  });
}

export default reducer;
export type { IVideoStyleState };
